<div class="container">
  <header class="jumbotron">
    <p>{{ content }}</p>
  </header>
</div>
